"use strict";

class SalesImportController {

    constructor($timeout,
                $window,
                Upload,
                SSHttpService,
                SSConfigService,
                SSAlertService,
                SSUtilService,
                OTPService,
                SSAppService,
                SSAwsService,
                SSUserService,
                SSConfirmationService
    ) {
        const self = this;

        self.$timeout = $timeout;
        self.$window = $window;
        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT;
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.importParams = {};
        self.salesDataFileProcessed = false;
        self.salesImageFilesProcessed = false;
        self.salesAssets = {};

        self.getDeveloperProperties();
    }

    getDeveloperProperties() {
        const self = this;

        self.properties = [];

        let url = 'sec/developer/properties';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let _properties = response.data.properties;

            jQuery.each(_properties, function (index, property) {
                if (property.status === self.PROPERTY_STATUS_APPROVED
                    || property.status === self.PROPERTY_STATUS_LISTED
                    || property.status === self.PROPERTY_STATUS_ARCHIVED
                ) {
                    self.properties.push(property);
                }
            });

            self.$timeout(function () {
                jQuery("#property-select").niceSelect('update');
            });
        });
    }

    validateImportParams() {
        const self = this;

        if (!self.property_id) {
            return;
        }
        if (!self.importParams.salesExcelFile) {
            return;
        }

        return true;
    }

    importSales() {
        const self = this;

        if (!self.importParams.salesExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadSalesExcel(self.importParams.salesExcelFile);
            }
        );
    }

    uploadSalesExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/sales/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(
            function (response) {
                loading(false);
                self.progressUploadingFiles = false;

                response = response.data ? response.data : {};

                if (response.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                if (!response.data.sales) {
                    self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                    return;
                }

                self.importData = response.data;

                if (self.importParams.salesAssetFiles && self.importParams.salesAssetFiles.length) {
                    self.uploadSalesFiles(self.importParams.salesAssetFiles);
                } else {
                    self._importSales();
                }

            }, function (response) {

                self.progressUploadingFiles = false;
                self.SSAlertService.parseAndDisplayError(response);

            }, function (evt) {
            }
        );
    }

    uploadSalesFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.salesAssets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Assets uploaded successfully.');

                    self.salesAssets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importSales();
                    }
                });
            });
        });
    }

    _importSales() {
        const self = this;

        let importUrl = 'sec/developer/import/sales';

        let params = {
            property_id: self.property_id,
            sales: self.importData.sales,
            sale_payments: self.importData.sale_payments,
            sale_payment_instruments: self.importData.sale_payment_instruments,
            sale_subsales: self.importData.sale_subsales,
            sale_subsale_buyers: self.importData.sale_subsale_buyers,
            assets: self.salesAssets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('All data is imported successfully.');
            self.progressUploadingFiles = false;
        });
    }

    goBack(){
        const self = this;

        self.$window.location.href = '/developer/sales/applications';
    }

}

SalesImportController.$inject = [
    '$timeout',
    '$window',
    'Upload',
    'SSHttpService',
    'SSConfigService',
    'SSAlertService',
    'SSUtilService',
    'OTPService',
    'SSAppService',
    'SSAwsService',
    'SSUserService',
    'SSConfirmationService'
];
app.controller('SalesImportController', SalesImportController);